define([
	"dojo/_base/declare",
	"csi/def",
	"csi/html",
	"csi/util"
], function(declare,def,html,util) {

	return declare(null, {
		m_name: null,

		constructor: function(/*XMLNode*/xn) {
			this.m_id = util.getProperty(xn, "Id");
			this.m_class = util.getProperty(xn, "Class");
		},

		isLabel: function() {
			return true;
		},

		isValid: function() {
			return !!this.m_id;
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			this.m_name = lr.resolveHeadingNames(this.key, null, null, null, this.m_id).name;
		},

		keyToHtml: function(/*Context*/ctx, /*DOMNode*/refNode) {
			def.processClass(this, refNode);
			html.setInnerText(refNode, this.m_name);
		}
	});
});